
<template>
    <loading v-model:active="IsLoading"
             :can-cancel="false"
             color="white"
             background-color="black"
             :opacity="0.8"
             :is-full-page="true">
        <!-- Content goes before the "after" slot -->
        <!-- Define the "after" slot using the "v-slot" directive -->
        <template v-slot:after>
            <div style="margin-top:18px;color:white;position:relative;left:-10px;">Please Wait...</div>
        </template>
    </loading>
    <form id="uploadfrm">
        <div style="">
            <div>
                <div class="row">
                    <div class="col col-12">
                        <file-pond style="width:270px;"
                                   class="filepond"
                                   name="upload-instance-1"
                                   ref="pond"
                                   class-name="my-pond"
                                   label-idle="Drop files here..."
                                   :allowMultiple="allowMultipleUpload"
                                   :accepted-file-types="allowedFileTypes"
                                   allowImageTransform="true"
                                   :allowImageValidateSize="allowImageValidateSize"
                                   :imageValidateSizeMinWidth="imageValidateSizeMinWidth"
                                   :imageValidateSizeMaxWidth="imageValidateSizeMaxWidth"
                                   :imageValidateSizeMinHeight="imageValidateSizeMinHeight"
                                   :imageValidateSizeMaxHeight="imageValidateSizeMaxHeight"
                                   imagePreviewMaxFileSize="1MB"
                                   max-file-size="1000000000"
                                   v-bind:files="UploadFiles"
                                   v-on:error="OnUploadError"
                                   v-on:init="handleFilePondInit"
                                   v-on:addfile="OnFileAdded"
                                   v-on:processfilestart="OnProcessFilestart"
                                   v-on:processfile="FileUploaded"
                                   v-on:processfiles ="FilesUploaded" />
                    </div>
                </div>
            </div>
            <div v-if="uploadError">
                <p>Upload Error: {{ uploadError }}</p>
            </div>
        </div>
    </form>

</template>

<style>
    .filepond--credits{
        display:none;
    }
</style>




<script>

    /*

    Usage:
      <filepondupload @uploads-complete="ShowFilesDone" />

      methods:{
            ShowFilesDone() {
                alert('Upload complete');
            }
        }

    */
    import axios from '@shared/AdminAxios.js';
    import { ref, nextTick } from 'vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/css/index.css';
    import vueFilePond from 'vue-filepond';

    // Import plugins
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size/dist/filepond-plugin-file-validate-size.esm.js';
    import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size/dist/filepond-plugin-image-validate-size.esm.js';


    //// Import styles
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImageValidateSize);

    export default {
        name: 'filepondupload',
        emits: ['upload-complete', 'uploads-complete', 'upload-error', 'upload-fileadded', "uploads-started"],
        components: { Loading, FilePond },
        props: {
            createUrl: {
                type: String,
                default: () => ('/Files/CreateFile')
            },
            patchUrl: {
                type: String,
                default: () => ('/Files/UploadFileChunk/')
            },
            orderid: {
                type: Number,
                default: () => (null)
            },
            orderitemid: {
                type: Number,
                default: () => (null)
            },
            sessionid: {
                type: String,
                default: () => ('00000000-0000-0000-0000-000000000000')
            },
            allowImageValidateSize: {
                type: Boolean,
                default: () => (false)
            },
            imageValidateSizeMinHeight: {
                type: Number,
                default: () => (50)
            },
            imageValidateSizeMaxHeight: {
                type: Number,
                default: () => (50)
            },
            imageValidateSizeMinWidth: {
                type: Number,
                default: () => (50)
            },
            imageValidateSizeMaxWidth: {
                type: Number,
                default: () => (50)
            },
            allowedFileTypes: {
                type: String,
                default: () => ("image/png, image/jpeg, image/gif")
            },
            allowMultipleUpload: {
                type: Boolean,
                default: () => (true)
            },
            confirmUploadOverwrite: {
                type: Boolean,
                default: () => (false)
            },
            configFilePond: {
                type: Object,
                default: () => ({})
            },
            doImagePreview: {
                type: Boolean,
                default: () => (true)
            },
        },
        data() {
            return {

                IsLoading: false,
                UploadFiles: [],
                uploadError: '',
            };
        },
        methods:
        {
            processFiles: function () {
                this.$refs.pond.processFiles();
            },
            removeFiles: function (options) {
                this.$refs.pond.removeFiles(options);
            },
            OnProcessFilestart: function () {
                this.$emit("uploads-started");
            },
            OnFileAdded: function (err, file) {
                this.$emit('upload-fileadded', err, file);
            },
            FilesUploaded: function () {
                this.$emit('uploads-complete');
            },
            FileUploaded: function (err, dat) {
                this.$emit('upload-complete', dat, err);
            },
            handleFilePondInit: function () {
                console.log('FilePond has initialized');

                // example of instance method call on pond reference
                this.$refs.pond.getFiles();
            },
            OnUploadError: function (err) {
                var dat = {};
                try {
                    dat = JSON.parse(err);
                } catch (e) { }
                this.$emit('upload-error', dat);
            }
        },
        computed:
        {

        },
        beforeMount: function () {

        },
        mounted: function () {
           
            var that = this;
            var config = this.configFilePond;
            config.server = {
                process: {
                    url: that.createUrl,
                    headers: function (file, metadata)
                    {
                        return {
                            "RequestVerificationToken": document.querySelector('input[name="__RequestVerificationToken"]').value,
                            "Upload-Length": file.size,
                            "Upload-Name": file.name,
                            "upload-overwrite": that.confirmUploadOverwrite,
                            "oderid": that.orderid,
                            "orderitemid": that.orderitemid,
                            "sessionid": that.sessionid
                        };
                    },
                    ondata: (formData) => {
                        return formData;
                    },
                    onerror: (response) => {
                        
                        var dat = {};
                        try {
                            dat = JSON.parse(response);
                        } catch (e) { }
                        this.$emit('upload-error', dat);
                    },
                },
                patch: {
                    url: that.patchUrl,
                    headers: {
                        'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value, // Replace with the actual CSRF token
                    },
                    onerror: (response) => {
                        var dat = {};
                        try {
                            dat = JSON.parse(response);
                        } catch (e) { }
                        this.$emit('upload-error', dat);
                    },
                },
                revert: null,
                restore: null,
                load: null,
                fetch: null,
            };
            
            this.$refs.pond._pond.setOptions(config);

        },
        beforeUnmount: function () {

        }
    }
</script>
